// extracted by mini-css-extract-plugin
export default {"boton":"UsuarioListaScreen_boton__Lbb4Q","containerTable":"UsuarioListaScreen_containerTable__5WSVc","subtitulo":"UsuarioListaScreen_subtitulo__0xUSx"};